/**
 * `DbDriver` over the SQLite-WASM worker.
 *
 * The connection itself still lives in `lib/db/worker.ts` and stays in this
 * app: the sqlite3-wasm + OPFS VFS ladder is irreducibly web. What moved out
 * is everything above it, so this file is now the whole of the browser's
 * database story — a request/response channel to a worker, wearing the
 * interface the engine asks for.
 */
import type { DbDriver, DbInfo, Statement } from '@kapture/platform';
import { all, openDatabase, run, tx } from '@/lib/db/sqlite';

export type { DbInfo, Statement };

export const webSqliteDriver: DbDriver = { openDatabase, run, all, tx };
